import {
  QueryFunction,
  QueryKey,
  useMutation,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { NotificatoinsApiService } from 'features/Notifications/api/dashboard-api.services';
import { NotificationListResponse, ReadNotificationDTO} from 'features/users';
import { NotificationListPaginated } from 'features/users/components/users-filter-form';
import { queryClient } from 'providers';
import qs from 'qs';

import { NotificationsQueryKeys } from './query-keys';

// ../api/dashboard-api.services
const { getNotificationList,readNotification } = NotificatoinsApiService();




const getUsersQuery = (
  params:NotificationListPaginated,
  options?: UseQueryOptions<NotificationListResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<NotificationListResponse>;
  options?: UseQueryOptions<NotificationListResponse>;
} => ({
  queryKey:NotificationsQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getNotificationList(params as any, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetNotificationList = (
  params: NotificationListPaginated,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();
     
  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};





export const useReadNotification = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: ReadNotificationDTO) => {
      return readNotification(payload);
    },
    {
      onError: (error) => {

        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: NotificationsQueryKeys.lists(),
          }),
          // queryClient.invalidateQueries({
          //   queryKey: NotificationsQueryKeys.detail(),
          // }),
        ]);
        if(data==1){
          message.success("This notification has been read.");
        }else{
            message.error('Something went wrong.');
        }
        
      },
    },
  );
};






